import React from "react";
import { Spotlight } from "../ui/spotlight";
const PlacementFinal = () => {
  return (
    <div className="relative flex h-[40rem] w-full overflow-hidden rounded-md bg-black/[0.96] antialiased md:items-center md:justify-center">
      {/* <div
        className={cn(
          "pointer-events-none absolute inset-0 [background-size:40px_40px] select-none",
          "[background-image:linear-gradient(to_right,#171717_1px,transparent_1px),linear-gradient(to_bottom,#171717_1px,transparent_1px)]"
        )}
      /> */}

      {/* Background with dots + gradient overlay */}
      <div
        className="pointer-events-none absolute inset-0 z-10 "
        style={{
          background:
            "radial-gradient(circle at center, transparent 80%, rgba(0,0,0,0.96) 100%)",
        }}
      />

      {/* Background with dots */}
      <div
        className="absolute left-1/2 top-0 bottom-0 z-0 w-full max-w-7xl -translate-x-1/2"
        style={{
          backgroundImage: "radial-gradient(#404040 1px, transparent 1px)",
          backgroundSize: "var(--dot-bg-size)",
        }}
      />

      {/* Center gradient fade */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background:
            "radial-gradient(ellipse at center, transparent 20%, black 70%)",
        }}
      />

      <Spotlight
        className="-top-40 left-0 md:-top-20 md:left-60"
        fill="white"
      />
      <div className="relative z-10 mx-auto w-full max-w-7xl p-4 pt-20 md:pt-0">
        <h1 className="bg-opacity-50 bg-gradient-to-b from-neutral-50 to-neutral-400 bg-clip-text text-center text-4xl font-bold text-transparent md:text-6xl">
          <span className="bg-text-gradient text-transparent bg-clip-text">
            Shortlisting
          </span>{" "}
          <br /> is already in progress.
        </h1>
        <p className="mx-auto mt-4 max-w-lg text-center text-base font-normal text-neutral-300">
          If you're serious about placements — this is your shot.
        </p>

        <div className="pt-2 flex justify-center">
          <button
            className="group relative px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:translate-y-[-2px] overflow-hidden"
            onClick={() => window.open("https://forms.gle/75EvB3WvKUGFTEvw8")}
          >
            <div
              className="absolute -inset-[2px] rounded-lg"
              style={{
                background:
                  "conic-gradient(from 0deg, #3b82f6, #8b5cf6, #3b82f6, transparent, transparent, transparent, transparent, transparent)",
                animation: "spin 2s linear infinite",
              }}
            ></div>
            <div className="absolute inset-[2px] bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg"></div>
            <span className="relative z-10 flex items-center gap-2 text-sm font-semibold">
              Secure Your Spot
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlacementFinal;
